import type { LinkComponent } from '@tanstack/react-router';
import { createLink } from '@tanstack/react-router';
import * as React from 'react';
import type { LinkProps } from 'react-aria-components';
import {
  composeRenderProps,
  Link,

} from 'react-aria-components';

import type { ButtonBaseProps } from './utils.ts';
import { buttonStyles } from './utils.ts';

type Props = ButtonBaseProps
  & { active?: boolean }
  & LinkProps;

export function StyledLink({ children, ...props }: Props) {
  return (
    <Link
      {...props}
      className={composeRenderProps(
        props.className,
        (className, renderProps) => buttonStyles({
          ...renderProps,
          color: props.color,
          variant: props.variant,
          size: props.size,
          isActive: renderProps.isPressed || props.active,
          className,
        }),
      )}
    >
      <>
        {props.icon?.component}
        {children}
      </>
    </Link>
  );
}

const CreatedLink = createLink(StyledLink);

export const ButtonLink: LinkComponent<typeof StyledLink> = (props) => {
  return <CreatedLink preload="intent" {...props} />;
};
